// extracted by mini-css-extract-plugin
module.exports = {"root":"accessories_root__E1TKh","in-view":"accessories_in-view__DLoaT","color":"accessories_color__x1H_2","_header-wrapper":"accessories__header-wrapper__nDQyd"};